/**
 * @name defaults
 * @description Apollo default state used in stateLink
 */
export const defaults = {
  currentUser: {
    id: '',
    loggedIn: false,
    firstName: '',
    lastName: '',
    roles: [],
    __typename: 'CurrentUser',
  },
};
